import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
const BeforeLoginRoute = ({ element }) => {
  const { isLogin, menu } = useSelector((state) => state?.auth);
  console.log("menu ==>", `/${menu?.[0]?.router}`);
  const navigateLink = `/${menu?.[0]?.router}`;
  if (!isLogin) {
    return element;
  }
  return <Navigate to={navigateLink ? navigateLink : "/login"} />;
};

export default BeforeLoginRoute;
